import { REFS_BY_TYPE_LABELS_MAP } from "../RefsByTypeTitles/constants.js";
import { SelectRefLinkValueForType } from "../RefLinkForm/components/SelectRefLinkValueForType.js";
import { useEffect, useState } from "react";
import { Button, ButtonGroup, FormLayout, Icon } from "@therms/atalaya";
import { IoLink } from "react-icons/io5";
import { jsx, jsxs } from "react/jsx-runtime";
import { MdDeleteForever } from "react-icons/md";
import { useFormikContext } from "formik";
//#region src/modules/shared/RefsByTypeForm/index.tsx
function RefsByTypeForm({ controller, data }) {
	const form = useFormikContext();
	const [refsByTypeKeys, setRefsByTypeKeys] = useState(data ? Object.keys?.(data) : []);
	useEffect(() => {
		if (data) setRefsByTypeKeys(Object.keys?.(data));
	}, [data]);
	return /* @__PURE__ */ jsxs("div", { children: [/* @__PURE__ */ jsxs("div", {
		className: "space-x-xs flex flex-wrap items-center justify-between",
		children: [/* @__PURE__ */ jsxs("div", {
			className: "space-x-xs flex items-center",
			children: [/* @__PURE__ */ jsx(Icon, {
				color: "subtle",
				Icon: IoLink
			}), /* @__PURE__ */ jsx("div", { children: controller })]
		}), /* @__PURE__ */ jsx("div", {
			className: "w-fit",
			children: /* @__PURE__ */ jsxs(ButtonGroup, {
				size: "sm",
				variant: "main",
				children: [
					!refsByTypeKeys?.includes("eventIds") && /* @__PURE__ */ jsx(Button, {
						onClick: () => setRefsByTypeKeys([...refsByTypeKeys, ...["eventIds"]]),
						children: "Events"
					}),
					!refsByTypeKeys?.includes("locationIds") && /* @__PURE__ */ jsx(Button, {
						onClick: () => setRefsByTypeKeys([...refsByTypeKeys, ...["locationIds"]]),
						children: "Locations"
					}),
					!refsByTypeKeys?.includes("locationLogEntryIds") && /* @__PURE__ */ jsx(Button, {
						onClick: () => setRefsByTypeKeys([...refsByTypeKeys, ...["locationLogEntryIds"]]),
						children: "Log Entries"
					}),
					!refsByTypeKeys?.includes("recordIds") && /* @__PURE__ */ jsx(Button, {
						onClick: () => setRefsByTypeKeys([...refsByTypeKeys, ...["recordIds"]]),
						children: "Records"
					}),
					!refsByTypeKeys?.includes("reportIds") && /* @__PURE__ */ jsx(Button, {
						onClick: () => setRefsByTypeKeys([...refsByTypeKeys, ...["reportIds"]]),
						children: "Reports"
					}),
					!refsByTypeKeys?.includes("userIds") && /* @__PURE__ */ jsx(Button, {
						onClick: () => setRefsByTypeKeys([...refsByTypeKeys, ...["userIds"]]),
						children: "Users"
					})
				]
			})
		})]
	}), /* @__PURE__ */ jsx(FormLayout.Section, {
		space: "xxs",
		subTitle: form.errors["refs"] && form.submitCount ? /* @__PURE__ */ jsx("span", {
			className: "text-critical",
			children: "Refs must exist"
		}) : void 0,
		children: !!refsByTypeKeys?.length && refsByTypeKeys?.map((ref, i) => {
			return /* @__PURE__ */ jsxs("div", {
				className: "gap-xs space-x-xs grid grid-cols-4 items-center",
				children: [/* @__PURE__ */ jsxs("div", {
					className: "space-x-xs col-span-1 flex items-center",
					children: [/* @__PURE__ */ jsxs("div", {
						className: "text-color-subtle -mt-6 flex flex-col items-center justify-center",
						children: ["|", /* @__PURE__ */ jsx(Icon, { Icon: IoLink })]
					}), /* @__PURE__ */ jsx("span", {
						className: "pl-xxs min-w-fit",
						children: REFS_BY_TYPE_LABELS_MAP?.[ref]?.single
					})]
				}), /* @__PURE__ */ jsxs("div", {
					className: "space-x-xxs col-span-3 flex w-full",
					children: [/* @__PURE__ */ jsx("div", {
						className: "flex-1",
						children: /* @__PURE__ */ jsx(SelectRefLinkValueForType, {
							bypassLocationLogLocationSelect: true,
							combineSelected: true,
							multi: true,
							onChangeValue: (value) => {
								if (!value?.length) form.setFieldValue(`refsByType.${[ref]}`, void 0);
								else form.setFieldValue(`refsByType.${[ref]}`, value);
							},
							type: REFS_BY_TYPE_LABELS_MAP?.[ref]?.type,
							value: form.values.refsByType?.[ref]
						})
					}), /* @__PURE__ */ jsx(Button, {
						onClick: () => {
							setRefsByTypeKeys(refsByTypeKeys?.filter((key) => key !== ref));
							form.setFieldValue(`refsByType.${[ref]}`, void 0);
						},
						size: "sm",
						subtle: true,
						variant: "critical",
						children: /* @__PURE__ */ jsx(Icon, { Icon: MdDeleteForever })
					})]
				})]
			}, i);
		})
	})] });
}
//#endregion
export { RefsByTypeForm };

//# sourceMappingURL=index.js.map